import React from "react";
import { useLocation } from "react-router-dom";
import DiscountsPage from "./DiscountsPage";

/**
 * Wrapper component for DiscountsPage that can receive initial data from navigation state.
 * This mirrors the pattern used in CustomerDetailWrapper to avoid unnecessary refetches.
 */
const DiscountsPageWrapper = () => {
  const location = useLocation();
  const initialPromotion = location.state?.promotion;
  const initialOpenRulesModal = Boolean(location.state?.openRulesModal);

  return (
    <DiscountsPage
      initialPromotion={initialPromotion}
      initialOpenRulesModal={initialOpenRulesModal}
    />
  );
};

export default DiscountsPageWrapper;
